import React from "react";
import * as Common from "@/utils/Common"; // Common.js
import styled from 'styled-components';
import { display, height } from "@mui/system";
const underDiv = { width: "279mm", borderWidth: "0px", borderStyle: "solid", /* marginBottom: "8mm", */position:"relative", display : "flex", justifyContent : "space-between", flexDirection : 'column', height : '40mm' };//, marginTop: "4mm"
const underTable = { border: "0px", borderCollapse: "collapse", borderStyle: "none", padding: "0px", width: "120mm",height : "10mm",  float : "right" };

class VmiCardPrintHorizon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nplx: "0",
            nply: "0",
            pathNm: null
        };
    }

    render() {

        const PrintStyleH = styled.div`
        @media screen, print {
                      
            body {
            font-family: "HanSerif"; //, "Times", "Times New Roman Custom";
            }
            div {
                background-color:;
                margin: 0px;
                padding: 0px;
                box-sizing:border-box;
            }
            table {
                border-collapse:collapse;
                border-style:none;
                margin: 0px;
                padding: 0px;
                box-sizing:border-box;
            }
            tr{
                width:100%;
                // height: 10mm;
                margin: 0px;
                padding: 0px;
            }
            td{
                margin: 0px;
                padding: 0px;
                background-color: white;
                font-family : "HanSerif";
                border:0px solid black;
                box-sizing:border-box;
            }
            .wrapDiv {
                //  width: 297mm;
                //  height: 210mm;
                // box-sizing: border-box;
                // border-style: dotted;
                // border-width: 0px;
                width: 100%;
                max-width: 297mm;
                overflow: hidden;
                box-sizing: border-box;

            }
            .cardHead{
            font-family : "HanSerif";
            }
            .headInfoStyle {
                font-size: 14pt;
                letter-spacing:-1px;
                font-family : "HanSerif";
            }
            .headInfoStyleDetail {
                height: 6.5mm;
                margin-bottom: 2px;
                font-size: 14pt;
                letter-spacing:-1px;
                font-family : "HanSerif";
            }
            .seqNumberStyle {
                text-align: center;
                border: 0px;
                padding: 0;
                margin: 0;
                width: 36px;
                font-size: 9pt;
                height: 0mm;
            }
            .seqTdStyle {
                border: 0px;
                padding: 0;
                margin: 0;
                font-size: 16pt;
                vertical-align: top;
                font-family : "3of9Barcode";
            
            }
            .barcodeTableStyle {
                border-collapse: collapse;
                border-spacing: 0;
                border: 0px;
                width: 361px;
            }
            .barcodeTdStyle {
                border: 0px;
                padding: 0;
                margin: 0;
                font-size: 18.3pt;
                vertical-align: top;
                font-family: "3of9Barcode";
            }
            
            .seqTableStyle {
                border-collapse: collapse;
                border-spacing: 0;
                border: 0px;
                width: 726px;
                height: 11mm;
            }
            .detailTableStyle {
                border-collapse: collapse;
                border-spacing: 0;
                border: 0px;
                width: 279mm;
                table-layout: fixed;
                font-family : "HanSerif";
                width : 100%
            }
            .headerTh {
               border: 0.5px solid #2e2e2e;
               text-align: center;
               color:black;
               font-size: 11pt;
               font-family: "HanSerif";
               vertical-align: middle;
               height: 4.5mm;
            }
            .noTd2 {
                border-bottom : 1px solid;
                text-align: center;
                font-size: 10pt;
                vertical-align: middle;
                
            }
            .partNoTD {
                text-align: left;
                font-size: 15pt;
                vertical-align: middle;
                font-family: "Times", "Times New Roman Custom";
                font-weight:bold;
                border-top: 0px;
            }
            .pdnoTD12, .vmitd83 {
                text-align: left;
                font-size: 12pt;
                vertical-align: middle;
                font-family: "Times", "Times New Roman Custom";
                border-top: 0px;

                
            }
            .td81 {
                text-align: left;
                font-size: 8pt;
                vertical-align: middle;
                border-color: black;
            }
            .vmitd82 {
                text-align: left;
                font-size: 8pt;
                vertical-align: middle;
                border-bottom : 1px solid;
            }
            .vmitd14 {
                text-align: right;
                font-size: 14pt;
                vertical-align: middle;
                border-bottom : 1px solid;
            }
            .vmitd12 {
                text-align: center;
                font-size: 12pt;
                vertical-align: middle;
                border-bottom : 1px solid;
            }
            .vmitd10 {
                text-align: center;
                font-size: 10pt;
                vertical-align: middle;
                border-bottom : 1px solid;
            }
            .vmitd84 {
                text-align: left;
                font-size: 9pt;
                vertical-align: middle;
                
                // padding-left: 7px;
            }
            .td91 {
                text-align: center;
                font-size: 9pt;
                vertical-align: middle;
                border-color: black;
            }
            .td92 {
                text-align: center;
                font-size: 9pt;
                vertical-align: middle;
                border-bottom : 1px solid;
            }
            .vmitd92 {
                text-align: right;
                font-size: 8pt;
                vertical-align: middle;
                border-bottom : 1px solid;
                
             
            }
            .tdptnm {
                text-align: left;
                font-size: 10pt;
                vertical-align: middle;
                border-bottom : 1px solid;
                font-family: "Times", "Times New Roman Custom";
                whiteSpace:nowrap;
            }
            .gateTd {
                text-align: left;
                font-size: 9pt;
                vertical-align: middle;
                border-color: black;
                
                
            }
            .caseQty {
                text-align: right;
                font-size: 9pt;
                vertical-align: middle;
                font-weight: bold;
                
            }
            .npqtTd {
                text-align: center;
                vertical-align: middle;
                font-size: 11pt;
                border-bottom : 1px solid;
                font-weight: bold;
            }
            .confirmBtnTop {
                border-width : 1px;
                border-style : 'solid',
                height : 10mm;
                width : 25mm;
                vertical-align : 'middle',
                border-color: black;
                text-align: center;
                font-size: 10pt;
                vertical-align: middle;
                
            }
            .confirmBtnBottom {
                border-bottom : 1px solid;
                text-align: center;
                font-size: 10pt;
                vertical-align: middle;
                // font-family: "Times", "Times New Roman Custom";
                font-weight:bold;
            }

            div.pagebreak {
            break-after: always !important;
            page-break-after: always !important;
            page-break-inside: avoid !important;
            }
        }
        `;


        const { printData } = this.props;
        // const simpleArray = [1,2];
        const simpleArray = [1];

        const cardInfo = printData
            ? printData.map((data, index) => {
                
                const seqBarcodeList = data.detail.map((item, index) => {
                    const blankTdArray = [];
                    if (index === data.detail.length - 1) {
                        let blankTdCount = 8 - data.detail.length;

                        for (let i = 0; i < blankTdCount; i++) {
                            blankTdArray.push(
                                <>
                                    <td style={index===1?{ width: "125px" }:index===2?{ width: "124px" }:index===3?{ width: "122px" }:index===4?{ width: "116.5px" }:index===5?{ width: "110px" }:{ width: "83px" }}></td>
                                </>
                            );
                        }
                    }

                    return (
                        
                        <>
                        
                            <td className="seqTdStyle" style={{width: "37px" }} >
                                *{item.DSEQ}*
                            </td>
                            {data.detail.length > 6 && data.detail.length !== 8
                            ? <td style={index===0?{ width: "82px" }:index===7?{ width: "30px" }:{width: (51)+(index+29)+"px"}}></td>
                            : data.detail.length === 8
                            ? <td style={index===0?{ width: "89px" }:index===7?{ width: "34px" }:{width: (58)+(index+30)+"px"}}></td>
                            :<td style={index===0?{ width: "82px" }:index===7?{ width: "30px" }:{width: (52)+(index+29)+"px"}}></td>
                            }
                            
                            {blankTdArray}
                        </>
                    );
                });

                const seqBarcodeList2 = data.detail.map((item, index) => {
                    const blankTdArray = [];
                    if (index === data.detail.length - 1) {
                        let blankTdCount = 8 - data.detail.length;

                        for (let i = 0; i < blankTdCount; i++) {
                            blankTdArray.push(
                                <>
                                    <td style={index===1?{ width: "125px" }:index===2?{ width: "124px" }:index===3?{ width: "122px" }:index===4?{ width: "116.5px" }:index===5?{ width: "110px" }:{ width: "83px" }}></td>
                                </>
                            );
                        }
                    }

                    return (
                        
                        <>
                        
                            <td className="seqTdStyle" style={{width: "37px",position: "relative",top: "-3px",backgroundColor: "transparent" }}>
                                *{item.DSEQ}*
                            </td>
                            {data.detail.length > 6 && data.detail.length !== 8
                            ? <td style={index===0?{ width: "82px" }:index===7?{ width: "30px" }:{width: (51)+(index+29)+"px"}}></td>
                            : data.detail.length === 8
                            ? <td style={index===0?{ width: "89px" }:index===7?{ width: "34px" }:{width: (58)+(index+30)+"px"}}></td>
                            : <td style={index===0?{ width: "82px" }:index===7?{ width: "30px" }:{width: (52)+(index+29)+"px"}}></td>
                            }
                            
                        </>
                    );
                });

                
                const seqList = data.detail.map((item, index) => {
                    return (
                        <>
                            <td className="seqNumberStyle" style={{position: "relative",top:"-4px",backgroundColor:"transparent",textAlign:"left",paddingLeft:"16px"}}>{item.DSEQ}</td>{/*position: "relative",top:"-7px",left:"-7px"*/}
                            <td style={{display:"block"}}></td>
                        </>
                    );
                });
                
                const chek = data.head.chek;
                
                const gate = data.detail.map((item, index) => {
                    return (
                        <>
                            {index===0?item.GATE:""}
                        </>
                    );
                });

                const plnm = data.detail.map((item, index) => {
                    return (
                        <>
                            {index===0?item.PLNM:""}
                        </>
                    );
                });

                const prif = data.detail.map((item, index) => {
                    return (
                        <>
                            {index===0?item.PRIF:""}
                        </>
                    );
                });

                const cano = data.detail.map((item, index) => {
                    return (
                        <>
                            {index===0?item.CANO:""}
                        </>
                    );
                });
                const HMC = data.evGubn === "partner" ? "[협력업체용]" : '[HMC용]'
                
            
                return (
                    <>
                        {simpleArray.map((n, simpleIndex) => (
                            <div key={"VmiCardPrintHorizon"+ n} className="wrapDiv horizontalContent">
                                <div className="headerCard" style={{ width: "278.9", height: "24mm", /* border : '1px solid',  */display : "flex", alignItems : "flex-end"}}>
                                    <div className="blank" style={{ width: "96mm" }}></div>
                                    {/* <div className="cardHead"
                                        style={{ float: "left", fontSize: "20pt", width: "85mm", height : "11mm",  position: "relative", backgroundColor: "#000000" , color : "#ffffff", textAlign : 'center'}}
                                    > 납입CARD [VMI 입하용]   </div> */}

                                    {/* <div className="blank" style={{ width: "8mm" }}></div> */}
                                    {/* 85 8 92 */}
                                    {chek === 'W' ?
                                        <>
                                            <div className="cardHead"
                                                style={{ float: "left", fontSize: "20pt", width: "112mm", height: "11mm", position: "relative", backgroundColor: "#000000", color: "#ffffff", textAlign: 'center' /* , padding : "1.5mm" */ }}
                                            >백지카드 납입CARD [VMI 입하용]</div>
                                            {/* <div style={{ float: "right", width: "77mm", paddingLeft: "0px" }}></div> */}
                                        </>

                                        :
                                        <>
                                            <div className="cardHead"
                                                style={{ float: "left", fontSize: "20pt", width: "85mm", height: "11mm", position: "relative", backgroundColor: "#000000", color: "#ffffff", textAlign: 'center' /* , padding : "1.5mm" */ }}
                                            >납입CARD [VMI 입하용]</div>
                                            <div className="blank" style={{ width: "8mm" }}></div>
                                        </>
                                    }
                                    <div style={{ float: "right", width: `${chek === 'W'?"60":"87"}mm`, paddingLeft: "0px" }}>
                                        {chek === 'W' ?
                                            <table className="barcodeTableStyle">
                                                    <tbody>
                                                        <tr>
                                                            <td className = "barcodeTdStyle" style={{fontSize:"20pt"}}>
                                                                
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                            </table>
                                            :   <table className = "barcodeTableStyle" style ={{height:"5mm"}} >
                                                    <tbody>
                                                        <tr>
                                                            <td className="barcodeTdStyle"style={{position: "relative",top:"0px",backgroundColor: "transparent"}}>
                                                                *{data.head.dlno}*
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="barcodeTdStyle" style={{position: "relative",top:"0px",backgroundColor: "transparent"}}>
                                                                *{data.head.dlno}*
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            }
                                    </div>
                                     
                                </div>
                                <div className="comment" style={{ display: "flex", height: '33mm', width : '278.9'/* , border : '1px solid blue' */ }}>
                                    <div className="comment_0" style={{ float: "left", width: "2mm" }}>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="comment_1"  style={{ float: "left", width: "94mm", display : 'flex', flexDirection : 'column', justifyContent : 'space-evenly'}}>
                                        <div className="headInfoStyle" style={{ fontSize: "16pt" }}>납품서 번호 : <span className="headInfoStyleDetail">{data.head.dlno}</span></div>
                                        <div className="headInfoStyle">납품일 :<span className="headInfoStyleDetail"> {prif}{/* {this.state.pathNm === "ROM3J"?" [재발행]":""} */}</span></div>
                                        <div className="headInfoStyle">공급자 : <span className="headInfoStyleDetail"> {data.head.vnt1} {data.head.vdnm}</span>
                                        </div>
                                    </div>
                                    <div className="comment_2" style={{ float: "left", width: "85mm", display : 'flex', flexDirection : 'column', justifyContent : 'space-around'}}>
                                        <div className="headInfoStyle" style={{ fontSize: "16pt", display : 'flex', justifyContent : 'center' }}>{HMC}</div>
                                        <div className="headInfoStyle"></div>
                                        <div className="headInfoStyle" style={{ display: "flex", justifyContent: "space-evenly" }} >
                                            <div style={{width : "17mm"}}></div>
                                            <div style={{ textAlign: "left" }}><img src="/images/pass.png" alt="공지" title="공지" style={{height: "17px",marginTop: "2px"}} /></div>
                                            <div style={{width : "25mm"}}></div>
                                            <div className="headInfoStyle" style={{ width : "37mm",   whiteSpace : 'nowrap' }}>납품처 :  <span style={{ display: "inline-block", width: "3ch" }}></span>{plnm}<span style={{ display: "inline-block", width: "1ch" }}></span>{gate}</div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <div className="comment_3" style={{ float: "left", width: "100mm" }}>
                                        <div style={{fontSize : '13pt', height : '13mm', display : "flex", flexDirection : 'column',justifyContent : 'center',  textAlign : 'center'}} className="headInfoStyle">{this.state.pathNm === "ROM3J"?" 재발행":""}</div>
                                        <div className="headInfoStyle" >
                                            {
                                                chek === 'W' ?  "백지카드 입고 증빙번호 : ___________________"
                                            :
                                            <span style={{ display: "inline-block", width: "10ch" }}></span>
                                            }
                                        </div>
                                        <div ></div>
                                        <div className="headInfoStyle" style={{ float: "right", height : '17mm', display : 'flex', flexDirection : 'column'}}>ⓡ</div>
                                    </div>
                                </div>
                                
                                <div style={{ width : '278.9', height: '113mm' }}>
                                    <div ></div>
                                    <table className="detailTableStyle"> 
                                    <col width="11mm" />   {/* NO */}
                                    <col width="47mm" />   {/* 품번품명 */}
                                    <col width="16mm" />   {/* */}
                                    <col width="16mm" />   {/*  납품수량*/}
                                    <col width="23mm" />   {/*  수납수/용기수*/}
                                    <col width="23mm" />   {/* */}
                                    <col width="17mm" />   {/* */}
                                    <col width="17mm" />   {/* */}
                                    <col width="43mm" />   {/* */}
                                    <col width="31mm" />   {/* */}
                                    <col width="4mm" />    {/* */}
                                    <col width="33mm" />   {/* */}
                                    <tbody>
                                        <tr style={{height : '6.5mm'}}>
                                            <td className = "headerTh" rowSpan="2" >No.</td>
                                            <td className = "headerTh" style={{ borderBottomStyle: "none" }} colSpan="2">품번</td>
                                            <td className="headerTh" style={{ borderBottomStyle: "none" }}>납품</td>
                                            <td className="headerTh" rowSpan="2">수납수/용기수</td>
                                            <td className = "headerTh" rowSpan="2">용기번호</td>
                                            <td className="headerTh" rowSpan="2">담당</td>
                                            <td className = "headerTh" style={{  borderBottomStyle: "none",letterSpacing:"1px" }}>입하</td>
                                            <td className = "headerTh" rowSpan="2" >업체명</td>
                                            <td className = "headerTh"  style={{  borderBottomStyle: "none",letterSpacing:"1px" }}>
                                                계약번호
                                            </td>
                                            <td></td>
                                            <td className = "headerTh"  rowSpan="2">
                                                특기사항
                                            </td>
                                        </tr>
                                        <tr style={{height : '6.5mm'}}>
                                            <td className = "headerTh"  style={{  borderTopStyle: "none" }} colSpan="2">품명</td>
                                            <td className="headerTh" style={{ borderTopStyle: "none" }}>수량</td>
                                            <td className = "headerTh" style={{  borderTopStyle: "none",letterSpacing:"1px" }}>구분</td>
                                            <td className = "headerTh" style={{  borderTopStyle: "none",letterSpacing:"1px" }}>품목번호</td>
                                            <td></td>
                                        </tr>
                                        {data.detail.map((item, dindex) => {
                                            const blankTrArray = [];
                                            if (dindex === data.detail.length - 1) {
                                                let blankTdCount = 8 - data.detail.length;

                                                for (let i = 0; i < blankTdCount; i++) {
                                                    blankTrArray.push(
                                                        <>
                                                            <tr key={item.PTNO +"blank"+ dindex}>
                                                                <td style={{height : "10mm"}} ></td>
                                                                <td style={{height : "10mm"}} ></td>
                                                                <td style={{height : "10mm"}} ></td>
                                                                <td style={{height : "10mm"}}></td>
                                                                <td style={{height : "10mm"}}></td>
                                                                <td style={{height : "10mm"}}></td>
                                                                <td style={{height : "10mm"}}></td> 
                                                                <td style={{height : "10mm"}}></td>
                                                                <td style={{height : "10mm"}}></td>
                                                                <td style={{height : "10mm"}}></td>
                                                                <td style={{height : "10mm"}}></td>
                                                                <td style={{height : "10mm"}}></td>
                                                            </tr>
                                                            <tr >
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}} ></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}} ></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}} ></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                                <td style={{height : "10mm",borderBottom:"1px solid white"}}></td>
                                                            </tr>
                                                        </>
                                                    );
                                                }
                                            }
                                            var prcd = "";
                                            if (item.PRCD && item.PRCD.trim() !== "") {
                                                if (n === 1) {
                                                    {/* 공장코드변경전 OLD */}
                                                    // if (item.PLNT === "HV12" || item.PLNT === "HV14" || item.PLNT === "HV15")
                                                    if (item.PLNT === "1012" || item.PLNT === "1014" || item.PLNT === "1015")
                                                    {
                                                        prcd = `[${item.PRCD}]`;
                                                    }
                                                } else {
                                                    prcd = `[${item.PRCD}]`;
                                                }
                                            }
                                            return (
                                                <>
                                                    <tr key={item.PTNO +"data"+ dindex} style={{height : "4.2mm",borderTop:"0px"}}>
                                                        <td className="noTd2" rowSpan="2">{item.DSEQ}{/*순위 */}</td>
                                                        <td className="partNoTD"  style={{whiteSpace:"nowrap",position:"relative",borderBottom:"0px",borderTop:"0px",lineHeight:"15px",bottom:"-1px",letterSpacing:"1px"}}>{item.PTNO}</td>{/*품번  */}
                                                        <td className="partNoTD"  style={{borderBottom:"0px",borderTop:"0px",lineHeight:"15px"}}></td>{/**/}
                                                        <td className="vmitd14" rowSpan="2">{item.NPQT} {/*납입수량 */}</td>
                                                        <td className="vmitd12" rowSpan="2" >{/*용기당수량/수   */}{item.QYPC}/{item.CASEC}</td>
                                                        <td className="vmitd10" rowSpan="2">{item.CASE1} </td>
                                                        <td className="vmitd10" rowSpan="2"> {item.CRDX}</td>{/*담당  */}
                                                        <td className="vmitd10" rowSpan="2">{item.SJGB && item.SJGB.trim() === "00" ? "" : item.SJGB}</td>
                                                        <td className="vmitd10" rowSpan="2" > {data.head.vdnm}</td>{/*납입장소 */}
                                                        <td className="pdnoTD12" style={{position:"relative"/* ,bottom:"-2px" */}}> {item.DONO}</td>{/*발주번호 */}
                                                        <td></td>
                                                        <td className="noTd2" rowSpan="2"  style={dindex===7?{borderBottom:"0px"}:{borderBottom:"1px solid"}}></td> {/* */}
                                                    </tr>
                                                    <tr style={{ height: "4mm" }}>
                                                        <td className="tdptnm" style={{whiteSpace:"nowrap",letterSpacing:"-1px",borderTop:"0px"}}>
                                                            {item.PTNM}{/*품명 */}
                                                        </td>
                                                        <td className="tdptnm" style={{whiteSpace:"nowrap",letterSpacing:"-1px",borderTop:"0px"}}>
                                                            {prcd}{/*[서열코드]  */}
                                                        </td>
                                                        <td className="vmitd83" style={{borderBottom : "1px solid"}}  >{item.DOPT}</td>{/* {item.ODGB}*/}
                                                        <td></td>
                                                    </tr>
                                                    {blankTrArray}
                                                </>
                                            );
                                        })}
                                    </tbody>
                                    </table>
                                </div>
                                <div style={underDiv}>
                                    <div style={{ height : '20mm'}}></div>

                                    <div style={{ display: "flex"}}>
                                         {chek === 'W' ?
                                            <table className="barcodeTableStyle">
                                                    <tbody>
                                                        <tr>
                                                            <td className = "barcodeTdStyle" style={{fontSize:"20pt"}}>
                                                                
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                            </table>
                                            :   <table className = "barcodeTableStyle" style ={{height:"5mm"}} >
                                                    <tbody>
                                                        <tr>
                                                            <td className="barcodeTdStyle"style={{position: "relative",top:"0px",backgroundColor: "transparent"}}>
                                                                *{data.head.dlno}*
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="barcodeTdStyle" style={{position: "relative",top:"0px",backgroundColor: "transparent"}}>
                                                                *{data.head.dlno}*
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                        }
                                        <div style={{ float: "right", width: "190mm" }}>
                                            <table style={underTable}>
                                                <tr>
                                                    <td className="confirmBtnTop" >검사자<br />확인</td>
                                                    <td style={{ borderWidth: "1px", borderStyle: "solid", height: "10mm", width : "31mm" }}>&nbsp;</td>
                                                    <td style={{ borderWidth: "1px", borderStyle: "solid", height: "10mm", width : "25mm", verticalAlign : "middle", textAlign : "center" }}>검수자<br />확인</td>
                                                    <td style={{ borderWidth: "1px", borderStyle: "solid", height: "10mm", width : "31mm" }}>&nbsp;</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div style={{ height : '10mm'}}></div>
                                    <div style={{ clear: "both" }}></div>
                                </div>
                            </div>
                        ))}
                        {index === printData.length - 1 ? "" : <div className={"pagebreak"}></div>}
                    </>
                );
            })
            : "";
        return   <div > <PrintStyleH style={{ pageBreakBefore: 'always' }}>{cardInfo}</PrintStyleH></div>
            ;
    }
}
export default VmiCardPrintHorizon;
